<div class="bubble">
  <ng-content />
</div>
